import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import CmtLinkedDocumentEditor from "./CmtLinkedDocumentEditor";

export default function CmtModal_EditLinkedDocuments(props) {
  const { modalState, toggleModal, divisionId, issueId } = props;

  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);

  const [linkedDocuments, setLinkedDocuments] = useState([]);
  const [otherLinkedDocuments, setOtherLinkedDocuments] = useState("");

  useEffect(() => {
    if (modalState.data) {
      setLinkedDocuments(modalState.data.linkedDocuments);
      setOtherLinkedDocuments(modalState.data.otherLinkedDocuments);
    }
  }, []);

  const handleUpdate = (updatedData) => {
    if (!updatedData) return;
    console.log("upLd=", updatedData);
    setLinkedDocuments(updatedData.linkedDocuments || []);
    setOtherLinkedDocuments(updatedData.otherLinkedDocuments || "");
  };

  const handleClick_submit = async (e) => {
    e.preventDefault();
    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId,
      fieldsToUpdate: {
        linkedDocuments: linkedDocuments.map((ld) => ({ ...ld, issueId })),
        otherLinkedDocuments,
      },
    });
    await dispatch(cmtIssueActions.update(issueId));
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"xl"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="file-alt" className="fa-fw mr-2" />
        Edit Linked Documents
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-12 mb-0">
            <div className="card">
              <div className="card-body p-3">
                <CmtLinkedDocumentEditor
                  divisionId={divisionId}
                  onUpdate={handleUpdate}
                  data={modalState.data || null}
                />
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="open"
            id="open"
            className="btn btn-primary mr-2"
            onClick={handleClick_submit}
          >
            {fetching && (
              <span className="mr-2 mt-1">
                <FontAwesomeIcon
                  icon="spinner"
                  className="loading-spinner"
                  style={{ color: "white" }}
                />
              </span>
            )}
            <b>Submit</b>
          </button>
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
